import React from 'react';

const FinanceReports = () => {
	return <></>;
};

export default FinanceReports;
